import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';
import { getDateString, withRetry } from '../utils/utils';
import { config } from '../config';
import axios from 'axios';

export interface MarketDate {
    date: string;
    open: string;
    close: string;
    session_open: string;
    session_close: string;
    settlement_date: string;
}

export interface LookupState {
    marketDates: MarketDate[];
    loading: boolean;
    error: string | null;
}

// Initial state
const initialState: LookupState = {
    marketDates: [],
    loading: false,
    error: null,
}

export const fetchMarketDates = createAsyncThunk<MarketDate[], void, { rejectValue: string }>(
    'lookup/fetchMarketDates',
    async (params, thunkAPI) => {
        try {
            const end = new Date();
            let start = new Date();
            start.setDate(start.getDate() - 7);
            const endDate = getDateString(end);
            const startDate = getDateString(start);
            const history = await withRetry(async () => {
                const result = await axios({
                    baseURL: config.alpaca.baseUrl,
                    method: 'get',
                    url: `v2/calendar?start=${startDate}&end=${endDate}`,
                    headers: {
                        'APCA-API-KEY-ID': config.alpaca.keyId,
                        'APCA-API-SECRET-KEY': config.alpaca.secretKey,
                        'accept': 'application/json'
                    }
                  });
                return result.data;
            }, 2);

            return history;
        } catch (error) {
            return thunkAPI.rejectWithValue('Network error occurred');
        }
    }
);

export const lookupSlice = createSlice({
    name: 'symbol',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(fetchMarketDates.fulfilled, (state, action) => {
            state.loading = false;
            state.marketDates = action.payload;
        });
        builder.addMatcher(isAnyOf(fetchMarketDates.pending), (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addMatcher(isAnyOf(fetchMarketDates.rejected), (state, action) => {
            state.loading = false;
            state.error = action.payload || 'Something went wrong';
        });
    },
});
